// extracted by mini-css-extract-plugin
export default {"overlay":"yu-z","bodyOpen":"zu-z","content":"Au-z","header":"Bu-z","close":"Cu-z","closeNoHeading":"Du-z"};